export const errorHandler = (error: Error) => {
  console.error(error);

  if (error.message) {
    console.error("Error", error.message);
    return error.message;
  }
  return error.toString();
};
